import React from "react";

import {
	NoContentImage,
	NoContentSubText,
	NoContentText,
	NoContentWrapper,
	ShowAllGamesButton,
} from "./elements";

const NoContent = ({ icon, heading, content, buttonText, showButton, onShowButtonClick }) => {
	return (
		<NoContentWrapper>
			<NoContentImage>{icon}</NoContentImage>
			<NoContentText>{heading}</NoContentText>
			<NoContentSubText>{content}</NoContentSubText>
			{showButton && (
				<ShowAllGamesButton onClick={onShowButtonClick}>{buttonText}</ShowAllGamesButton>
			)}
		</NoContentWrapper>
	);
};

export default NoContent;
